import { render, staticRenderFns } from "./white-wine-light-medium.vue?vue&type=template&id=26bbbc32"
import script from "./white-wine-light-medium.vue?vue&type=script&lang=js"
export * from "./white-wine-light-medium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports